import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { HTMLTable } from '@blueprintjs/core';
import { Children, isValidElement, useMemo, } from 'react';
import { TableHeader } from './TableHeader';
import { TableRow } from './TableRow';
import { TableContext } from './tableContext';
function splitChildren(children) {
    const Rows = [];
    let Header = null;
    for (const child of Children.toArray(children)) {
        if (typeof child !== 'object' || !isValidElement(child)) {
            throw new Error('invalid Table child');
        }
        else if (child.type === TableRow) {
            Rows.push(child);
        }
        else if (child.type === TableHeader) {
            Header = child;
        }
        else {
            throw new Error('invalid Table child');
        }
    }
    return { Rows, Header };
}
export function Table(props) {
    const { bordered = false, compact = false, interactive = false, striped = false, color = '', children, ...tableProps } = props;
    const { Header, Rows } = splitChildren(children);
    const tableContextValue = useMemo(() => ({ color }), [color]);
    return (_jsx(TableContext.Provider, { value: tableContextValue, children: _jsxs(HTMLTable, { bordered: bordered, compact: compact, interactive: interactive, striped: striped, ...tableProps, children: [Header, _jsx("tbody", { children: Rows })] }) }));
}
Table.Row = TableRow;
Table.Header = TableHeader;
//# sourceMappingURL=Table.js.map